import React from 'react';
import Header from '../components/Header/Header';
import MiniatureVisualizer from '../components/MiniatureVisualizer/MiniatureVisualizer';
import Footer from '../components/Footer/Footer';

function VisualizerPage() {
  return (
    <>
      <Header />
      <main className="visualizer-page">
        <div className="container">
          <div className="visualizer-page-header">
            <h1 className="visualizer-page-title">
              AI Miniature Visualizer
              <span className="visualizer-beta-tag">Beta</span>
            </h1>
            <p className="visualizer-page-subtitle">
              Upload photos of your unpainted miniature and watch AI bring it to life with
              a custom color scheme and photorealistic visualization.
            </p>
          </div>
          <MiniatureVisualizer />
        </div>
      </main>
      <Footer />

      <style>{`
        .visualizer-page {
          padding-top: 5rem;
          padding-bottom: 4rem;
          min-height: 100vh;
          background: var(--bg-primary);
        }
        .visualizer-page-header {
          text-align: center;
          padding: 2.5rem 0 2rem;
        }
        .visualizer-page-title {
          font-size: 2.5rem;
          font-weight: 800;
          background: var(--gradient-primary);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 0.75rem;
        }
        .visualizer-page-subtitle {
          color: var(--text-secondary);
          max-width: 580px;
          margin: 0 auto;
          line-height: 1.7;
        }
        .visualizer-beta-tag {
          display: inline-block;
          font-size: 0.75rem;
          font-weight: 700;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #a78bfa;
          background: rgba(139, 92, 246, 0.15);
          border: 1px solid rgba(139, 92, 246, 0.4);
          border-radius: 0.35rem;
          padding: 0.15em 0.55em;
          vertical-align: middle;
          margin-left: 0.6rem;
          -webkit-text-fill-color: #a78bfa;
        }
      `}</style>
    </>
  );
}

export default VisualizerPage;
